import {
	SelectionsState,
	SelectionsActionTypes,
	SelectionStep,
	SET_SELECTION_STEP,
	SET_SELECTED_STYLE,
	SET_SELECTED_OPTIONS,
	SET_SELECTED_LAYOUT,
	SET_QR_CODE,
} from "./selectionsTypes";

const initialState: SelectionsState = {
	step: SelectionStep.Intro,
	layoutIndex: 0,
	optionsValue: 11,
	styleIndex: 0,
};

export function selectionsReducer(state = initialState, action: SelectionsActionTypes): SelectionsState {
	switch (action.type) {
		case SET_SELECTION_STEP:
			return {
				...state,
				step: action.step,
			};
		case SET_SELECTED_LAYOUT:
			return {
				...state,
				layoutIndex: action.layoutIndex,
			};
		case SET_SELECTED_STYLE:
			return {
				...state,
				styleIndex: action.styleIndex,
			};
		case SET_SELECTED_OPTIONS:
			return {
				...state,
				optionsValue: action.optionsValue,
			};
		case SET_QR_CODE:
			return {
				...state,
				qrCode: action.qrCode,
			};
		default:
			return state;
	}
}
